import { useReducer } from 'react';

export const INITIAL_STATE = {
    jointHolder: false,
    resident: false,
    underage: false,
    vulnerablyOlder: false,
};

const actions = {
    SHOW_ADVISE: 'SHOW_ADVISE',
    RESET_ADVISES: 'RESET_ADVISES',
};

const reducer = (state, action) => {
    switch (action.type) {
        case actions.SHOW_ADVISE: {
            return {
                ...state,
                ...action.payload,
            };
        }
        case actions.RESET_ADVISES: {
            return INITIAL_STATE;
        }
        default: {
            return state;
        }
    }
};

export const useAdvise = (initialState = INITIAL_STATE) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const handleShowAdvise = value => {
        dispatch({ type: actions.SHOW_ADVISE, payload: value });
    };

    const resetAdvises = () => {
        dispatch({ type: actions.RESET_ADVISES });
    };

    return {
        state,
        handleShowAdvise,
        resetAdvises,
    };
};
